"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configInstance = exports.Config = void 0;
const axios_1 = require("axios");
class Config {
    /**
     * Creates an instance of ChipperSDK.
     * @param {string} [baseUrl='http://localhost:3002/v1/'] Base API URL.
     * @param {string} jwtToken The JWT auth token for the signed-in user
     * @param {object} [axiosOptions={}] The default Axios options to use with each request
     * @memberof ChipperSDK
     */
    constructor(jwtToken, baseUrl = 'http://localhost:3002/v1/', axiosOptions = {}) {
        this.baseUrl = baseUrl;
        this.authToken = jwtToken;
        this.defaultOptions = axiosOptions;
        this.axiosInstance = axios_1.default;
        this.respInterceptor = null;
    }
    getBaseUrl() {
        return this.baseUrl;
    }
    setBaseUrl(baseUrl) {
        this.baseUrl = baseUrl;
    }
    getAuthUrl() {
        return this.authUrl;
    }
    setAuthUrl(authUrl) {
        this.authUrl = authUrl;
    }
    getComplianceUrl() {
        return this.complianceUrl;
    }
    setComplianceUrl(complianceUrl) {
        this.complianceUrl = complianceUrl;
    }
    getAuthToken() {
        return this.authToken;
    }
    setAuthToken(jwtToken) {
        this.authToken = jwtToken;
    }
    getOptions() {
        return this.defaultOptions;
    }
    setOptions(axiosOptions) {
        this.defaultOptions = axiosOptions;
    }
    setInterceptor(onSuccess, onFailure) {
        this.ejectInterceptor();
        this.respInterceptor = this.axiosInstance.interceptors.response.use(onSuccess, onFailure);
    }
    ejectInterceptor() {
        if (this.respInterceptor) {
            this.axiosInstance.interceptors.response.eject(this.respInterceptor);
        }
    }
}
exports.Config = Config;
exports.configInstance = new Config();
//# sourceMappingURL=config.js.map